module.exports = __webpack_public_path__ + "static/media/8043828481_334c0f2bf4_z.f8cb6817.jpg";